export default __webpack_public_path__ + "static/media/logo.f4a47748.svg";